import styled from 'styled-components';

export const RightSide = styled.div`
  flex: 1;
  min-width: 0;
`;
